// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TagFilledSvg from "@ant-design/icons-svg/es/asn/TagFilled";
import AntdIcon from '../components/AntdIcon';

var TagFilled = function TagFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: TagFilledSvg
  }));
};

TagFilled.displayName = 'TagFilled';
export default React.forwardRef(TagFilled);